"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainWorkEnv = exports.Motivations = exports.FieldWorkEnvs = exports.DeskWorkEnvs = void 0;
var DeskWorkEnvs;
exports.DeskWorkEnvs = DeskWorkEnvs;

(function (DeskWorkEnvs) {
  DeskWorkEnvs["OFFICE"] = "Office";
  DeskWorkEnvs["REMOTE"] = "Remote";
  DeskWorkEnvs["CONSULTANT"] = "Consultant";
})(DeskWorkEnvs || (exports.DeskWorkEnvs = DeskWorkEnvs = {}));

var FieldWorkEnvs;
exports.FieldWorkEnvs = FieldWorkEnvs;

(function (FieldWorkEnvs) {
  FieldWorkEnvs["FIELDWORKER"] = "FieldWorker";
  FieldWorkEnvs["FIELDNOMAD"] = "FieldNomad";
  FieldWorkEnvs["CUSTOMERFACING"] = "CustomerFacing";
})(FieldWorkEnvs || (exports.FieldWorkEnvs = FieldWorkEnvs = {}));

var Motivations;
exports.Motivations = Motivations;

(function (Motivations) {
  Motivations["WELLBEING"] = "Wellbeing";
  Motivations["RELATIONSHIPS"] = "Relationships";
  Motivations["CONTRIBUTE"] = "Contribute";
  Motivations["LEARN"] = "Learn";
  Motivations["REWARDS"] = "Rewards";
  Motivations["CHALLENGES"] = "Challenges";
})(Motivations || (exports.Motivations = Motivations = {}));

var MainWorkEnv;
exports.MainWorkEnv = MainWorkEnv;

(function (MainWorkEnv) {
  MainWorkEnv["DESK"] = "desk";
  MainWorkEnv["FIELD"] = "field";
})(MainWorkEnv || (exports.MainWorkEnv = MainWorkEnv = {}));
//# sourceMappingURL=types.js.map